import React from 'react';
const styles = {
    marginTop: "17px",
    marginLeft: "75px"
} 
const BottomWrapper = (props)=><section style={styles}>{props.children}</section>
export { BottomWrapper };



// WEBPACK FOOTER //
// ./src/components/common/BottomWrapper.js